import { useQuery } from "@tanstack/react-query"
import { getCompanyAddresses } from "@/lib/api/company.api"
import { useAuthStore } from "@/store/auth.store"

export function useCompanyAddresses(companyId: string | null | undefined) {
  const token = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["company-addresses", companyId],
    queryFn: async () => {
      if (!token) throw new Error("No token available")
      if (!companyId) throw new Error("No company ID available")
      return getCompanyAddresses(companyId, token)
    },
    enabled: !!companyId && !!token,
  })
}
